import { useEffect, useState } from 'react';
import type { ChatsVCardSetting } from '../../../constants/types';
import { getVCardTemplate } from './getVCardTemplate';

const blobToBase64 = (blob: Blob): Promise<string> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result as string;
      resolve(base64data?.replace(/(data:image\/(png|jpeg);base64,)/g, ''));
    };
  });
};

const imageUrlToBase64 = async (url: string): Promise<string | null> => {
  if (!url) return null;

  const data = await fetch(url);
  const blob = await data.blob();

  return blobToBase64(blob);
};

export const useGenerateVCard = (vcardProps: ChatsVCardSetting | null) => {
  const { image } = vcardProps || {};
  const [link, setLink] = useState('');
  const [base64Image, setBase64Image] = useState<string | null>('');

  useEffect(() => {
    const updatedImage = async () => {
      if (image) {
        const base64 = await imageUrlToBase64(image);
        setBase64Image(base64);

        return;
      }

      setBase64Image('');
    };

    updatedImage();
  }, [image]);

  useEffect(() => {
    if (!vcardProps) {
      setLink('');

      return;
    }

    const vcard = getVCardTemplate({ ...vcardProps, image: base64Image || '' });

    const file = new Blob([vcard], {
      type: 'text/vcard'
    });
    const encodingFile = URL.createObjectURL(file);
    setLink(encodingFile);

    return () => URL.revokeObjectURL(encodingFile);
  }, [base64Image, vcardProps]);

  return link;
};
